import React, { useCallback, useEffect } from "react";
import LayoutNode from "../Definitions/LayoutNode";
import { useTrackingEvent } from "../../Hooks/useAddTrackingEvent";
import { utils } from "../../utils/Utils";
import { UserContext } from "../Definitions/UserContext";


export default function RenderDormantBookButton({ component, website, siteData }: { component: LayoutNode, website: string, siteData: UserContext }) {
  const [TrackEvent] = useTrackingEvent();


  let btnType = component.componentAttributes["buttonType"] ?? "primary";

  let external = website;
  let isEditor = (window as any).isEditor == true;
  let btnText = component.componentAttributes["buttonText"] ?? "Book Now";
  if(btnText.trim().length==0){
    btnText="Book Now";
  }

  const handleTrackEvent = useCallback(
    () => {
      if (!isEditor && (siteData.isDormant || siteData.isDisplayHomeInVagaroPlus)) {
        let Reffrer = window.location.pathname.split("/").find(val => val !== "") || "";
        let UserID = "VjyaDUqIaJ9ZTvKEP9kn6g==";
        let LoginDetails = utils.ReadCookie();
        let LoginUserID = LoginDetails.csEncUid;
        if (typeof LoginUserID != "undefined" && LoginUserID != null && LoginUserID != "") {
          UserID = LoginUserID;
        };
        TrackEvent(
          siteData.parentbid || "QX9p3jq6~mMP6js9ReeSqw==",
          siteData?.staticencbid ?? "QX9p3jq6~mMP6js9ReeSqw==",
          UserID,
          2,
          window.location.origin + "/" + Reffrer,
          "",
          () => { }
        );
      }
    },
    [TrackEvent, isEditor, siteData],
  );


  if (!isEditor && (!external || external.length < 2))
    return null;

  if (!external.startsWith("http")) {

    if (external.startsWith("www")) { // if a www add the assumed protocol
      external = "https://" + external;
    }
    else { // if just a normal string like website.com assume it's a www address and add both
      external = "https://www." + external;
    }

  }

  return (
    <a
      className={"v-button no-a center-all gap-med w-full h-full " + btnType}
      rel="noreferrer"
      target={"_blank"}
      href={external ?? ""}
      onClick={
        isEditor
          ? (e) => {
            e.preventDefault();
          }
          : (e) => {
            handleTrackEvent();
          }
      }
    ><span>{btnText}</span> <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 512 512"><path d="M432 320H400a16 16 0 0 0 -16 16V448H64V128H208a16 16 0 0 0 16-16V80a16 16 0 0 0 -16-16H48A48 48 0 0 0 0 112V464a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V336A16 16 0 0 0 432 320zM488 0h-128c-21.4 0-32.1 25.9-17 41l35.7 35.7L135 320.4a24 24 0 0 0 0 34L157.7 377a24 24 0 0 0 34 0L435.3 133.3 471 169c15 15 41 4.5 41-17V24A24 24 0 0 0 488 0z" /></svg></a>
  );
}
